import { Box, Stack, Typography, Button, Chip } from '@mui/material';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { useDispatch, useSelector } from 'react-redux';
import { setViewerOpen } from '../../../../redux/tatWizardSlice';

// In-module breadcrumb bar — mirrors the Pricing wizard's WizardTopBar. No user
// avatar here: the global app TopBar already shows the signed-in user.
export default function TatTopBar({ onOpenHelp }) {
  const dispatch = useDispatch();
  const merchantName = useSelector((s) => s.tatWizard.merchantName);
  const flowMode = useSelector((s) => s.tatWizard.flowMode);
  const inFlow = flowMode !== null;

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 40,
        bgcolor: 'rgba(255,255,255,0.92)',
        backdropFilter: 'saturate(180%) blur(10px)',
        borderBottom: 1,
        borderColor: 'divider',
        px: 2.5,
        py: 1.25,
        display: 'flex',
        alignItems: 'center',
        gap: 1.75,
      }}
    >
      <Stack direction="row" spacing={1.25} alignItems="center">
        <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: 12.5 }}>
          Merchant Setup <Box component="span" sx={{ color: 'grey.400', mx: 0.5 }}>›</Box>
          <Box component="b" sx={{ color: 'text.primary' }}>TAT Setup</Box>
        </Typography>
      </Stack>
      <Stack direction="row" spacing={1.25} alignItems="center" sx={{ ml: 'auto' }}>
        {inFlow && merchantName && (
          <Chip
            size="small"
            label={merchantName}
            sx={{
              bgcolor: 'primary.lighter',
              color: 'primary.dark',
              fontWeight: 600,
              fontSize: 12,
              border: 1,
              borderColor: 'primary.light',
            }}
          />
        )}
        {inFlow && (
          <Button
            size="small"
            variant="outlined"
            color="inherit"
            startIcon={<VisibilityOutlinedIcon sx={{ fontSize: 16 }} />}
            onClick={() => dispatch(setViewerOpen(true))}
            sx={{ fontSize: 12.5 }}
          >
            CP × Code TATs
          </Button>
        )}
        <Button
          size="small"
          variant="outlined"
          color="inherit"
          startIcon={<MenuBookOutlinedIcon sx={{ fontSize: 16 }} />}
          onClick={onOpenHelp}
          sx={{ fontSize: 12.5 }}
        >
          Help
        </Button>
      </Stack>
    </Box>
  );
}
